import { get } from './httpBridge';
// дефалтный бридж для API, который использует HTTP методы
// нужен, если никакой бридж не поставили в дескрипторе, то его подгружать
export default function Bridge() {
  return {
    get: async (param) => get('path', param),
  };
}